import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import { Header, Sidebar } from "../../Layout";
import { Link, useHistory } from 'react-router-dom'
import { makePayment } from '../../../actions/userDashboardAction';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';

const PaymentForm = (props) => {
    const { user } = useSelector(state => state.auth)
    const dispatch = useDispatch();
    const history = useHistory();
    const [paymentMode, setPaymentMode] = useState(false)
    const [planId, setPlanId] = useState()
    const { handleSubmit, } = useForm({
        mode: "onBlur",
    });
    const elements = useElements()
    const stripe = useStripe()
    const onPaymentSubmit = async (values, event) => {
        event.preventDefault();
        if (!stripe || !elements) {
            return;
        }
        const card = elements.getElement(CardElement);
        const result = await stripe.createToken(card);

        if (result.error) {
            //console.log(result);
            toast.error(result.error.message)
        } else {
            // console.log(result)
            const paymentData = {
                plan_id: planId,
                payment_token: result.token.id
            };
            //console.log(paymentData)
            dispatch(makePayment(paymentData, history));
            hideEditModal();
        }
    };
    const showEditModal = id => {
        setPaymentMode(true);
        setPlanId(id);
    }
    const hideEditModal = () => {
        setPaymentMode(false)
        setPlanId()
    }
    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Make Payment</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Payment / Make Payment</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">

                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                            <h3>Make payment</h3>
                        </div>
                    </div>


                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="card card-radius">
                                <div className="header card-header custum-bg-warning rounded">
                                    <h2 className="text-white">Subscribe to a plan</h2>
                                </div>
                                <div className="row text-center subscription_plans align-items-end m-2 mt-5 mb-5">
                                    {props.plans && props.plans.map((plan, index) => (
                                        plan.status === true &&
                                        <div key={index} className="col-lg-4 col-sm-6 form-group ">
                                            <div className={`p-5 rounded-lg shadow ${plan.id === user.subscription_plan_id ? ' subscription-plan-active' : 'bg-white'} `} >
                                                <h1 className="h6 text-uppercase font-weight-bold mb-4">{plan.name}</h1>
                                                <h2 className="h1 font-weight-bold">${plan.discounted_price}<span className="text-small font-weight-normal ml-2 text-muted">/ <del>${plan.price}</del></span></h2>
                                                <div className="custom-separator my-4 mx-auto bg-warning"></div>
                                                <ul className="list-unstyled my-5 text-small text-left">
                                                    <li className="mb-3"> <i className="fa fa-check mr-2 text-primary"></i> { plan.disk_space } MB Disk Space</li>
                                                    <li className="mb-3"> <i className="fa fa-check mr-2 text-primary"></i> { plan.projects_limit } Projects Limit</li>
                                                    <li className="mb-3"> <i className="fa fa-check mr-2 text-primary"></i> { plan.partners_limit } Partners Limit</li>
                                                    <li className="mb-3"> <i className="fa fa-check mr-2 text-primary"></i> { plan.members_limit } Members Limit</li>
                                                    {/* <li className="mb-3"> <i className="fa fa-check mr-2 text-primary"></i> {plan.partners_limit} Partners Limit</li> */}
                                                    {/* <li className="mb-3 text-muted"> <i className="fa fa-times mr-2"></i> <del>Unlimited Subdomain</del> </li>*/}
                                                    {/* <li className="mb-3 text-muted"> <i className="fa fa-times mr-2"></i> <del>Automatic Cloud Backup</del> </li>  */}
                                                </ul> 
                                                <button disabled={plan.id === user.subscription_plan_id ? true : false} onClick={() => showEditModal(plan.id)} className="btn btn-warning btn-block p-2 shadow rounded-pill">Subscribe</button>
                                            </div>
                                        </div>

                                    ))}
                                </div>
                                {/* Modal for editing tod */}
                                <Modal show={paymentMode} onHide={hideEditModal}>
                                    <Modal.Header>
                                        <Modal.Title id="contained-modal-title">Make Payment</Modal.Title>
                                        <button className='btn btn-outline-danger' onClick={hideEditModal}><i className='fa fa-close'></i></button>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <form className="form-auth-small" id="payment-form" onSubmit={handleSubmit(onPaymentSubmit)}>
                                            <div className="col-md-12">
                                                {paymentMode &&
                                                    <>
                                                        <CardElement id="card-element" />
                                                    </>
                                                }
                                            </div>
                                            <Modal.Footer className='mt-3'>
                                                <button type="submit" className='btn button' disabled={!stripe || !elements}>Pay</button>
                                                <button className='btn btn-outline-danger' onClick={hideEditModal}>Close</button>
                                            </Modal.Footer>
                                        </form>
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default PaymentForm;
